import { workbenchUrl } from "@crm/shared/workbench-link";
import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * 302 保旧链：学员任务页已外化至 workbench（学员学习面归拢）。
 * 员工管理面（班期 in-class-tasks tab、小组任务 tab）仍在 CRM。
 */
export const Route = createFileRoute("/student-tasks")({
  beforeLoad: () => {
    throw redirect({ href: workbenchUrl("/student-tasks") });
  },
});
